import React from "react";

function SvgIcMapPoi030(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M11.5 9.998c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5m12.158-3H14.659a3.496 3.496 0 00-3.159-2 3.5 3.5 0 100 7 3.496 3.496 0 003.159-2H17v2h2v-2h1v2h2v-2h1.659a3.476 3.476 0 00-.001-3M18 20h-3v-3h3c1.208 0 1.482.825 1.5 1.5 0 .451-.147 1.5-1.5 1.5m0-6h-6v12h3v-3h3c3.302 0 4.5-2.691 4.5-4.5 0-1.809-1.198-4.5-4.5-4.5"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi030;
